import axios from "axios";
import { waHref, isWaScheme, waWebHref, launchWaScheme } from "./whatsapp";

// Check-in desk API client: admin token if present, otherwise the staff PIN
// saved on the tablet (localStorage so it survives app restarts).
export const PIN_KEY = "checkin_pin";

export const checkinApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

checkinApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const pin = localStorage.getItem(PIN_KEY);
  if (pin) config.headers["X-HK-PIN"] = pin;
  return config;
});

export const hasCheckinAuth = () => !!(localStorage.getItem("admin_token") || localStorage.getItem(PIN_KEY));

export async function verifyStaffPin(pin) {
  await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/hk/verify-pin`, { pin });
  localStorage.setItem(PIN_KEY, pin);
  sessionStorage.setItem("hk_pin", pin); // lets the frigobar/reception page work too
}

export const fetchCheckinDay = (date) => checkinApi.get("/checkin/day", { params: { date } }).then((r) => r.data);
export const ensurePin = (id) => checkinApi.post(`/checkin/reservations/${id}/ensure-pin`).then((r) => r.data);
export const fetchPinWa = (id) => checkinApi.get(`/checkin/reservations/${id}/wa`).then((r) => r.data);
export const markReservation = (id, body) => checkinApi.post(`/checkin/reservations/${id}/mark`, body).then((r) => r.data);
export const sendFidelity = (id) => checkinApi.post(`/checkin/reservations/${id}/fidelity`).then((r) => r.data);
export const setGuestPhone = (id, phone) => checkinApi.patch(`/hk/reservations/${id}/phone`, { phone }).then((r) => r.data);
export const saveCheckinSettings = (body) => checkinApi.put("/checkin/settings", body).then((r) => r.data);

// Opens a new tab synchronously (popup-blocker safe on iPad), then points it to the URL once known.
export function openLater(fn) {
  const w = window.open("", "_blank");
  return fn()
    .then((url) => {
      const href = url ? waHref(url) : url;
      if (href && isWaScheme(href)) launchWaScheme(href, waWebHref(url), w);
      else if (href && w) w.location = href; else if (!w && href) window.location.href = href;
    })
    .catch((e) => { if (w) w.close(); throw e; });
}

// Guest questions queue (same data as Admin → Posta → Risposte ospiti), staff PIN allowed.
export const guestQuestionsApi = {
  list: () => checkinApi.get("/checkin/guest-questions/questions", { params: { status: "pending" } }).then((r) => r.data),
  faq: () => checkinApi.get("/checkin/guest-questions/faq").then((r) => r.data),
  send: (id, body) => checkinApi.post(`/checkin/guest-questions/questions/${encodeURIComponent(id)}/send`, body).then((r) => r.data),
  redraft: (id) => checkinApi.post(`/checkin/guest-questions/questions/${encodeURIComponent(id)}/redraft`).then((r) => r.data),
  skip: (id) => checkinApi.post(`/checkin/guest-questions/questions/${encodeURIComponent(id)}/skip`).then((r) => r.data),
};
